import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../context/ThemeContext';
import { TRANSFORMS, textStats, transformText } from '../../lib/textStats';
import CopyButton from './CopyButton';
import { buttonClass, fieldClass, labelClass, mutedClass, panelClass } from '../uiStyles';

const STAT_KEYS = ['chars', 'charsNoSpaces', 'words', 'sentences', 'paragraphs', 'lines'];

const TextTools = () => {
  const { isDarkMode } = useTheme();
  const { t, i18n } = useTranslation();
  const [text, setText] = useState('');

  const stats = useMemo(() => textStats(text), [text]);
  const format = (value) => value.toLocaleString(i18n.language);

  return (
    <div className="space-y-4">
      <div>
        <label className={labelClass(isDarkMode)} htmlFor="text-input">
          {t('useful.text.input')}
        </label>
        <textarea
          id="text-input"
          value={text}
          onChange={(event) => setText(event.target.value)}
          rows={8}
          placeholder={t('useful.text.placeholder')}
          className={`${fieldClass(isDarkMode)} resize-y text-sm`}
        />
      </div>

      <div className="grid grid-cols-3 sm:grid-cols-6 gap-2">
        {STAT_KEYS.map((key) => (
          <div key={key} className={`${panelClass(isDarkMode)} text-center`}>
            <p className={`text-xl font-bold ${isDarkMode ? 'text-primary' : 'text-green-600'}`}>
              {format(stats[key])}
            </p>
            <p className={`text-xs ${mutedClass(isDarkMode)}`}>{t(`useful.text.stats.${key}`)}</p>
          </div>
        ))}
      </div>

      <p className={`text-sm ${mutedClass(isDarkMode)}`}>
        {t('useful.text.readingTime', { minutes: stats.readingMinutes })}
        {stats.longestWord && ` · ${t('useful.text.longestWord', { word: stats.longestWord })}`}
      </p>

      <div className="flex flex-wrap gap-2">
        {Object.keys(TRANSFORMS).map((kind) => (
          <button
            key={kind}
            type="button"
            onClick={() => setText((value) => transformText(value, kind))}
            disabled={!text}
            className={buttonClass(isDarkMode)}
          >
            {t(`useful.text.transforms.${kind}`)}
          </button>
        ))}
        <CopyButton value={text} />
        <button type="button" onClick={() => setText('')} className={buttonClass(isDarkMode)} disabled={!text}>
          {t('useful.clear')}
        </button>
      </div>
    </div>
  );
};

export default TextTools;
